import { postMethod } from "../../../../function/helper";
import Swal from "sweetalert2";

const doSubmit = async (data, showModal, loading) => {
  const sumbitData = {
    ...data,
    email: data.email ? data.email : undefined,
    password_confirmation: data.confirmPassword,
  };

  loading(true);
  const response = await postMethod("/user/v1/register-agent", sumbitData);
  loading(false);

  if (response) {
    if (response.status === 201) {
      showModal();
    } else {
      Swal.fire({
        icon: "error",
        text: response.data.message,
        showConfirmButton: true,
        confirmButtonText: "متوجه شدم",
        confirmButtonColor: "red",
      });
    }
  }
};

export default doSubmit;
